import { CartItemUpdateInput } from '@/features/graphql/generated/graphql'
import { useCartKeyContext } from '@/features/pos/components/Cart/contexts/CartKey'
import { cartItemUpdateMutation } from '@/features/pos/components/OrderFinalization/mutations'
import { logger } from '@/features/pos/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { useMutation } from '@apollo/client'
import { useCallback } from 'react'
import invariant from 'tiny-invariant'

export const useUpdateCartItem = () => {
    const { cartKey } = useCartKeyContext()

    const handleError = useHandleErrorWithToast(logger)

    const [cartItemUpdate] = useMutation(cartItemUpdateMutation, { onError: handleError })

    return useCallback(
        async (item: CartItemUpdateInput) => {
            invariant(cartKey, 'cartKey must be set')

            await cartItemUpdate({
                variables: { cartKey, itemUpdate: item },
            })
        },
        [cartKey, cartItemUpdate]
    )
}
